export const buildUrlClient = (uri: string) => {
  return `/client/${uri}`;
};
